const dev = {
	API_ENDPOINT_URL: 'http://localhost:8080',
	PROFILE: 'DEV'
};

const beta = {
	API_ENDPOINT_URL: '',
	PROFILE: 'BETA'
};

const prod = {
	API_ENDPOINT_URL: '',
	PROFILE: 'PROD'
};

const getEnv = () => {
	switch (process.env.REACT_APP_NODE_ENV || 'production') {
		case 'development':
			return dev
		case 'staging':
		case 'beta':
			return beta
		case 'production':
			return prod
		default:
			break;
	}
}

export const env = getEnv()
